import { render, staticRenderFns } from "./HistorialEstampillasTab.vue?vue&type=template&id=a0eb34e4&scoped=true&"
import script from "./HistorialEstampillasTab.vue?vue&type=script&lang=js&"
export * from "./HistorialEstampillasTab.vue?vue&type=script&lang=js&"
import style0 from "./HistorialEstampillasTab.vue?vue&type=style&index=0&id=a0eb34e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0eb34e4",
  null
  
)

export default component.exports